export default {
	methods: {
		/**
		 * Prevent event on submit
		 **/
		onSubmit(event) {
			event.preventDefault();
		},

		/**
		 * Verifica se o usuário possui hashlogin
		 **/
		hasHashlogin() {
			if(this.hashlogin == null || this.hashlogin == 'null' || this.hashlogin == ''){
				return false;
			}

			return true;
		},

		/**
		 * Muda o tipo de input entre password ou texto
		 **/
		showPass() {
			if(this.typePass == 'password'){
				this.typePass = 'text';
			}else{
				this.typePass = 'password';
			}
		},

		/**
		 * Muda a configuração da página de
		 * login para primeiro acesso ou ao contrário
		 **/
		changeLoginOrFirstAccess() {
			this.isFirstAccess = !this.isFirstAccess;

			//Corrige a rota
			if (this.isFirstAccess) {
				this.disabled = this.usernameAndPasswordAreEmpty();

				this.title = this.$t('login_first_access');

				if (this.isSuper) {
					this.toFirstAccessSuper();
					return;
				}

				this.toFirstAccess();
			} else {
				this.title = this.$t('login_title');

				if (this.isSuper) {
					this.toLoginSuper();
					return;
				}

				this.toLogin();
			}
		},

		/**
		 * Remove os espaços nos dados de password
		 **/
		removeSpace() {
			if (typeof this.password != 'undefined' && this.password) {
				this.password = this.password.trim();
			}

			if (typeof this.password_confirm != 'undefined' && this.password_confirm) {
				this.password_confirm = this.password_confirm.trim();
			}

			if (typeof this.password_temp != 'undefined' && this.password_temp) {
				this.password_temp = this.password_temp.trim();
			}
		},

		/**
		 * Verifica se o usuário tem permissão de acesso
		 * @param Array info
		 * @param Array opcao
		 **/
		permission(info, opcao) {
			let ret = false;

			if(typeof this.perm.perm[info] != "undefined"){
				if(this.perm.perm[info][opcao] == '1'){
					ret = true;
				}
			}

			return ret;
		},

		/**
		 * Recebe atualização para username
		 * @param Array value
		 **/
		updateUsername(value) {
			this.username = value.username;
		},

		/**
		 * Recebe atualização para password
		 * @param Array value
		 **/
		updatePassword(value) {
			this.password = value.password;
		},

		/**
		 * Recebe atualização para password_confirm
		 * @param Array value
		 **/
		updateConfirmPassword(value) {
			this.password_confirm = value.password_confirm;
		},

		/**
		 * Recebe atualização para tokens
		 * @param Array value
		 **/
		updateToken(value) {
			this.tokens = value.tokens;
		},

		/**
		 * Recebe atualização para código de verificação
		 * @param Array value
		 **/
		updateCodeVerification(value) {
			this.codeVerification = value.codeVerification;
		},

		/**
		 * Recebe atualização para rememberComputer
		 * @param Array value
		 **/
		updateRememberComputer(value) {
			this.rememberComputer = value.rememberComputer;
		},

		/**
		 * Recebe atualização para urlGToken
		 * @param Array value
		 **/
		updateUrlGToken(value) {
			this.urlGToken = value.urlGToken;
		},

		/**
		 * Coloca o foco pelo id do elemento
		 * @param String elementId
		 **/
		focus(elementId) {
			document.getElementById(elementId).focus();
		},

		/**
		 * Verifica as regras para a senha, para retornar o check
		 * verdadeiro ou falso por item.
		 **/
		validatePasswordMustContain() {
			const password = this.password;

			this.passwordMustContain.forEach(rule => {
				switch (rule.key) {
					case 'characters':
					rule.valid = password.length >= 8;
					break;
					case 'lowercase':
					rule.valid = /[a-z]/.test(password);
					break;
					case 'capital_letters':
					rule.valid = /[A-Z]/.test(password);
					break;
					case 'special_character':
					rule.valid = /[!@#$%^&*(),.?":{}|<>]/.test(password);
					break;
					case 'numbers':
					rule.valid = /[0-9]/.test(password);
					break;
				}
			});
		},

		/**
		 * Verifica se a senha passou em todas as regras.
		 **/
		validateIfPasswordContainsAllRules() {
			let countRules = 0;

			this.passwordMustContain.map((x) => {
				if(x.valid) {
					countRules++;
				}
			});

			//Se todos forem validos, então retorna true
			if (this.passwordMustContain.length == countRules) {
				return true;
			}

			return false;
		},

		/**
		 * Muda a classe de cor do botão conforme habilitado ou desabilitado
		 **/
		buttonEnabled() {
			let classButton = 'form-control ';
			classButton += this.disabled ? 'btnBlueGrayOff' : 'btnBlueGrayOn';
			return classButton;
		},

		/**
		 * Verifica se a usuario e senha estão vazios.
		 **/
		usernameAndPasswordAreEmpty() {
			if((this.username != "" && this.username != null) && (this.password != "" && this.password != null)){
				return false;
			}

			return true;
		},

		/**
		 * Mascara o email
		 * @param String email
		 **/
		maskedEmail(email) {
			try {
				const [username, domain] = email.split('@');

				let maskedUsername = username.substring(0, 3) + '*'.repeat(username.length - 3);
				let maskedDomain = domain.substring(0, 3) + '*'.repeat(domain.length - 3);

				return maskedUsername + '@' + maskedDomain;
			} catch (error) {
				return "";
			}
		},
	},
}